import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import { ConfigElement } from "types/generated";
import Code from "ds/components/Code";

import useCellCopyAction from "../../useCellCopyAction";

const IntentProjectEnvironmentVariablesTableValueCell = ({
  item: variable,
  ...cellProps
}: TableSimpleCellProps<ConfigElement>) => {
  const isComputed = variable.runtime;
  const isSecret = variable.writeOnly;
  const isEmpty = !variable.value && !isComputed && !isSecret;

  const copyAction = useCellCopyAction({
    text: variable.value || "",
  });

  const actions = useMemo(
    () => (!isEmpty && !isComputed && !isSecret ? [copyAction] : []),
    [copyAction, isEmpty, isComputed, isSecret]
  );

  const value = useMemo(() => {
    if (isSecret) return "*****";
    if (isComputed) return "<computed>";
    return variable.value;
  }, [isSecret, isComputed, variable.value]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}
      {!isEmpty && (
        <TableCellText>
          <Code whiteSpaceVisible>{value}</Code>
        </TableCellText>
      )}
    </TableSimpleCell>
  );
};

export default IntentProjectEnvironmentVariablesTableValueCell;
